import createReducer from "./createReducer";
import { Session } from "rhombus-react";

export default createReducer(Session.initialState, Session.handler);
